import React from 'react'
import { useTranslation } from 'react-i18next'
import AdvertCard from '../AdvertCard/AdvertCard.component'
import { AdvertEntity } from '../../../domain'
import { GridList } from '../GridList'
import EmptyState from '../EmptyState/EmptyState.component'
import './AdvertList.styles.css'

type TAdvertListProps = {
  adverts?: AdvertEntity[]
  isLoading: boolean
  onDelete?: (advertUUID: string) => void
  searchQuery?: string
}

const AdvertList: React.FC<TAdvertListProps> = ({ 
  adverts = [],
  isLoading,
  onDelete,
  searchQuery = ''
}) => {
  const { t } = useTranslation()

  const emptyTitle = searchQuery 
    ? t('adverts-not-found', { ns: 'standard' }) 
    : t('no-adverts', { ns: 'standard' })
  
  const emptyDescription = searchQuery 
    ? t('adverts-not-found-by-query', { ns: 'standard', query: searchQuery })
    : t('no-adverts-description', { ns: 'standard' })

  return (
    <div className="advert-list-container">
      <GridList
        dataSource={adverts}
        loading={isLoading}
        renderItem={(wrappedItem) => (
          <AdvertCard advertModel={wrappedItem.originalItem as AdvertEntity} onDelete={onDelete} />
        )}
        emptyComponent={
          <EmptyState
            icon="📢"
            title={emptyTitle}
            description={emptyDescription}
          />
        }
      />
    </div>
  )
}

export default AdvertList
